import moment from 'moment-timezone';
import OsmOpeningHours from 'opening_hours';

class OpeningHours {
    /**
     * @param now string|number|Date
     * @param osmOpeningHoursString string
     */
    constructor({now, osmOpeningHoursString}) {
        if (now === undefined || now === null) {
            this.now = moment();
        } else if (now instanceof Date || typeof now === 'string' || typeof now === 'number') {
            this.now = moment(now);
        } else {
            throw new Error('Unsupported "now" format');
        }

        this.osmOpeningHours = new OsmOpeningHours(osmOpeningHoursString || 'closed');
    }

    getSince() {
        return moment(this.now).startOf('week');
    }

    getTo() {
        return moment(this.now).endOf('week');
    }

    getWeek() {
        const week = [];
        for (let i = moment(this.getSince()); i.isBefore(this.getTo()); i.add(1, 'day')) {
            week.push(i.format('dddd'));
        }

        return week;
    }

    getTable() {
        const intervals = this.osmOpeningHours.getOpenIntervals(
            this.getSince().toDate(),
            this.getTo().toDate()
        );

        const table = this.getWeek().map(dayOfWeek => ({dayOfWeek: [dayOfWeek], open: false}));

        intervals.forEach(interval => {
            const dow = moment(interval[0]).format('d');
            if (!table[dow].open) {
                table[dow].open = true;
                table[dow].hours = [];
            }

            const hours = `${moment(interval[0]).format('h:mm a')} - ${moment(interval[1]).format(
                'h:mm a'
            )}`;

            table[dow].hours.push(hours);
        });

        const updatedTable = table.reduce(
            (acc, cur) => {
                if (
                    acc.prev &&
                    (acc.prev.open === cur.open &&
                        JSON.stringify(acc.prev?.hours) === JSON.stringify(cur?.hours))
                ) {
                    if (acc.prev?.dayOfWeek) {
                        acc.prev.dayOfWeek.push(...cur.dayOfWeek);
                    }
                } else {
                    acc.result.push(cur);
                    acc.prev = cur;
                }
                return acc;
            },
            {
                result: [],
            }
        ).result;

        return updatedTable;
    }

    getStatus() {
        let nearly = false;
        let open = this.osmOpeningHours.getState(this.now.toDate());

        const nextChange = this.osmOpeningHours.getNextChange(this.now.toDate());
        if (nextChange) {
            if (Math.abs(moment.duration(this.now.diff(moment(nextChange))).asMinutes()) < 60) {
                nearly = true;
                // 'nearly open' actually means 'closed' and vise versa
                open = !open;
            }
        }

        return (nearly ? 'nearly-' : '') + (open ? 'open' : 'closed');
    }

    getStatusLabel() {
        let statusLabel;
        switch (this.getStatus()) {
            case 'closed':
                statusLabel = 'Closed';
                break;
            case 'nearly-open':
                statusLabel = 'Opening Soon';
                break;
            case 'nearly-closed':
                statusLabel = 'Closing Soon';
                break;
            case 'open':
                statusLabel = 'Open';
                break;
            default:
                statusLabel = undefined;
        }

        return statusLabel;
    }

    getStatusActionLabel() {
        const open = this.osmOpeningHours.getState(this.now.toDate());

        const nextChange = this.osmOpeningHours.getNextChange(this.now.toDate());
        if (!nextChange) {
            return undefined;
        }

        const action = open ? 'Closes' : 'Opens';

        return `${action} - ${moment(nextChange).format('h:mma')}`;
    }
}

export default OpeningHours;
